import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23173cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-visitor-form" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "请填写来访人信息", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "van-cell van-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "van-cell__title van-field__label" }, "车牌号", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title",
  style: {"margin-top":"20px"}
}, "请填写访问信息", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title",
  style: {"margin-top":"20px"}
}, "请填写被访人信息", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title",
  style: {"margin-top":"20px"}
}, "更多信息", -1))
const _hoisted_10 = {
  key: 1,
  class: "form-clause"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_CarNumberCom = _resolveComponent("CarNumberCom")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_rulesRegulations = _resolveComponent("rulesRegulations")!
  const _component_choose_visitor_target = _resolveComponent("choose-visitor-target")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_form, { onSubmit: $setup.onSubmit }, {
          default: _withCtx(() => [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.person_lists, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-visitor-item",
                key: item.key
              }, [
                (index != 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "form-delete",
                      onClick: ($event: any) => ($setup.deletePerson(index))
                    }, "删除", 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _createVNode(_component_van_cell_group, { inset: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      modelValue: item.name,
                      "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                      maxlength: "20",
                      required: "",
                      name: 'name' + index,
                      label: `来访人${index + 1 < 2 ? '' : index + 1}`,
                      placeholder: `请输入来访人${index + 1 < 2 ? '' : index + 1}姓名`,
                      rules: [{ required: true, message: `请输入姓名` }]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "placeholder"]),
                    _createVNode(_component_van_field, {
                      modelValue: item.mobile,
                      "onUpdate:modelValue": ($event: any) => ((item.mobile) = $event),
                      type: "tel",
                      name: 'mobile' + index,
                      label: "手机号",
                      maxlength: "11",
                      required: "",
                      placeholder: "请输入来访人手机号",
                      rules: [
                { required: true, message: '请输入手机号' },
                { pattern: $setup.validate.mobile.reg, message: $setup.validate.mobile.msg }
              ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]),
                    _createVNode(_component_van_field, {
                      modelValue: item.email,
                      "onUpdate:modelValue": ($event: any) => ((item.email) = $event),
                      type: "email",
                      name: 'email' + index,
                      label: "邮箱",
                      placeholder: "请输入来访人邮箱"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_CarNumberCom, {
                        ref_for: true,
                        ref: "cardNumber",
                        onChange: (el) => $setup.changeCarNumber(el, index)
                      }, null, 8, ["onChange"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            _createElementVNode("div", {
              class: "add-visitor-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.addPerson && $setup.addPerson(...args)))
            }, [
              _createVNode(_component_van_icon, { name: "plus" }),
              _createTextVNode(" 新增来访人")
            ]),
            _hoisted_7,
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.person_reason,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.person_reason) = $event)),
                  name: "person_reason",
                  label: "来访原因",
                  required: "",
                  maxlength: "100",
                  placeholder: "请输入来访原因",
                  rules: [{ required: true, message: '请填写来访原因' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.person_time_start.fieldValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.person_time_start.fieldValue) = $event)),
                  "is-link": "",
                  readonly: "",
                  required: "",
                  name: "datetimePicker",
                  label: "来访开始时间",
                  placeholder: "请选择来访开始时间",
                  "right-icon": "arrow",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.person_time_start.show = true))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  show: $setup.person_time_start.show,
                  "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (($setup.person_time_start.show) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      type: "datetime",
                      modelValue: $setup.person_time_start.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.person_time_start.value) = $event)),
                      "min-date": $setup.person_time_start.minDate,
                      filter: $setup.person_time_start.filter,
                      onConfirm: $setup.person_time_start.confirm,
                      onCancel: _cache[5] || (_cache[5] = ($event: any) => ($setup.person_time_start.show = false))
                    }, null, 8, ["modelValue", "min-date", "filter", "onConfirm"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.person_time_end.fieldValue,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.person_time_end.fieldValue) = $event)),
                  "is-link": "",
                  readonly: "",
                  name: "datetimePicker",
                  required: "",
                  label: "来访结束时间",
                  placeholder: "请选择来访结束时间",
                  "right-icon": "arrow",
                  onClick: $setup.clickTimeEnd
                }, null, 8, ["modelValue", "onClick"]),
                _createVNode(_component_van_popup, {
                  show: $setup.person_time_end.show,
                  "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (($setup.person_time_end.show) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      type: "datetime",
                      modelValue: $setup.person_time_end.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.person_time_end.value) = $event)),
                      "min-date": $setup.person_time_end.minDate,
                      "max-date": $setup.person_time_end.maxDate,
                      onConfirm: $setup.person_time_end.confirm,
                      onCancel: _cache[9] || (_cache[9] = ($event: any) => ($setup.person_time_end.show = false))
                    }, null, 8, ["modelValue", "min-date", "max-date", "onConfirm"])
                  ]),
                  _: 1
                }, 8, ["show"])
              ]),
              _: 1
            }),
            _hoisted_8,
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                ($setup.userInfo?.user_type == '1')
                  ? (_openBlock(), _createBlock(_component_van_field, {
                      key: 0,
                      modelValue: $setup.formData.visit_stores_name,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.formData.visit_stores_name) = $event)),
                      name: "visit_stores_name",
                      label: "被访对象",
                      required: "",
                      placeholder: "请输入被访对象名称",
                      rules: [{ required: true, message: '请输入被访对象名称' }]
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_van_field, {
                      key: 1,
                      modelValue: $setup.formData.visit_stores_name,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.formData.visit_stores_name) = $event)),
                      "is-link": "",
                      readonly: "",
                      name: "picker",
                      label: "被访对象",
                      required: "",
                      placeholder: "请选择被访对象",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.chooseVisitorTargetShow = true)),
                      "right-icon": "arrow",
                      rules: [{ required: true, message: '请选择被访对象' }]
                    }, null, 8, ["modelValue"])),
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.visit_user_name,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.formData.visit_user_name) = $event)),
                  name: "visit_user_name",
                  label: "被访人",
                  maxlength: "20",
                  required: "",
                  placeholder: "请输入被访人姓名",
                  rules: [{ required: true, message: `请输入被访人姓名` }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.visit_user_mobile,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.formData.visit_user_mobile) = $event)),
                  type: "tel",
                  name: "visit_user_mobile",
                  label: "被访人手机号",
                  required: "",
                  maxlength: "11",
                  placeholder: "被访人手机号",
                  rules: [
              { required: true, message: '请输入被访人手机号' },
              { pattern: $setup.validate.mobile.reg, message: $setup.validate.mobile.msg }
            ]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.visit_user_email,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.formData.visit_user_email) = $event)),
                  type: "email",
                  name: "visit_user_email",
                  label: "被访人邮箱",
                  placeholder: "请输入被访人邮箱"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            ($setup.formData.visit_diy_field.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9,
                  _createVNode(_component_van_cell_group, { inset: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.visit_diy_field, (field) => {
                        return (_openBlock(), _createBlock(_component_van_field, {
                          key: field.id,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          name: field.id,
                          label: field.title,
                          required: field.required,
                          placeholder: `请输入${field.title}`,
                          rules: [{ required: field.required, message: `请输入${field.title}` }]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "required", "placeholder", "rules"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            ($setup.configInfo.visit_slas.state == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_van_checkbox, {
                    modelValue: $setup.formData.checked,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.formData.checked) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("我已阅读并同意")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("span", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.formData.showRules = true))
                  }, "《服务协议及隐私政策》")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提交申请 ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    ($setup.configInfo?.visit_slas.content)
      ? (_openBlock(), _createBlock(_component_rulesRegulations, {
          key: 0,
          show: $setup.formData.showRules,
          "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => (($setup.formData.showRules) = $event)),
          content: $setup.configInfo?.visit_slas.content
        }, null, 8, ["show", "content"]))
      : _createCommentVNode("", true),
    _createVNode(_component_choose_visitor_target, {
      show: $setup.chooseVisitorTargetShow,
      "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => (($setup.chooseVisitorTargetShow) = $event)),
      multiple: "",
      onConfirm: $setup.visitorTargetConfirm
    }, null, 8, ["show", "onConfirm"])
  ], 64))
}